<div
  class="w-full p-8 bg-zinc-100 mon-portfolio flex-col justify-start items-start gap-2.5 inline-flex"
>
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div
    class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
  >
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div
        class="w-full p00 flex-col justify-start items-start gap-2.5 inline-flex"
      >
        <div
          class="self-stretch h-full flex-col justify-start items-start gap-5 flex"
        >
          <!-- Documents -->
          <!-- Titre -->
          <div
            class="self-stretch flex-col justify-start items-center gap-6 flex"
          >
            <div
              class="self-stretch flex-col justify-start items-start gap-6 flex"
            >
              <div
                class="self-stretch flex-col justify-start items-start gap-5 flex"
              >
                <div
                  class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex"
                >
                  <div
                    class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
                  >
                    <div class="text-4xl font-semibold mb-4">Mon portfolio</div>
                    <div>Vous pouvez gerer ici votre portfolio</div>
                  </div>
                  <div class="justify-start items-center gap-3 flex">
                    <button
                      class="px-4 py-2.5 title-btn rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex"
                      (click)="togglePopup()"
                    >
                      <div class="w-5 h-5 relative">
                        <img src="assets/icons/export.svg" alt="" />
                      </div>
                      <div
                        class="text-slate-700 font-semibold text-white leading-tight"
                      >
                        Importer
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Tableau -->
          <div
            class="self-stretch h-full flex-col justify-start items-center gap-4 flex"
          >
            <div
              class="self-stretch h-full flex-col justify-start items-start gap-8 flex"
            >
              <div
                class="self-stretch h-full flex-col justify-start items-start gap-4 flex"
              >
                <div
                  class="tableau-ctnr mb-6 self-stretch h-full flex-col justify-start items-start gap-4 flex"
                >
                  <table
                    style="table-layout: auto; word-break: normal"
                    class="mat-elevation-z8 w-full text-sm tableau mes-documents text-left rtl:text-right text-gray-500 dark:text-gray-400"
                  >
                    <thead class="text-sm font-medium f12 bg-orange text-white">
                      <tr>
                        <th scope="row" class="px-6 py-3">Nom de fichier</th>
                        <th scope="row" class="px-6 py-3">Date d'ajout</th>
                        <th scope="row" class="px-4 py-3">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let document of documentsList"
                        class="bg-white border-b ng-star-inserted"
                      >
                        <td
                          scope="row"
                          class="px-8 py-4 font-semibold text-gray-900 overflow-hidden"
                        >
                          <a
                            href="{{ url }}/opencontroller/content/{{
                              document.lienDocument
                            }}"
                            target="_blank"
                          >
                            {{ document.fileName }} <br /><span
                              class="file-size f12 text-gray-400"
                              >{{ document.size }} KB</span
                            >
                          </a>
                        </td>
                        <td scope="row" class="px-6 py-4 f14 font-semibold">
                          {{ document.created_At | date }}
                        </td>
                        <td
                          scope="row"
                          class="action-btn-ctnr f14"
                          style="padding-right: 0"
                        >
                          <button
                            class="action-btn cst-transition three-dots p-1 text-gray-700 text-center"
                          >
                            <div
                              class="actions-panel text-left rounded-lg shadow bg-white cst-transition"
                            >
                              <button
                                id=""
                                class="text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                              >
                                <a
                                  href="{{ url }}/opencontroller/content/{{
                                    document.lienDocument
                                  }}"
                                  target="_blank"
                                  >Afficher</a
                                >
                              </button>
                              <!-- <button
                            id=""
                            class="inter-regular text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition">
                            Modifier
                          </button> -->
                              <button
                                id=""
                                class="text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                                (click)="
                                  onDeleteDocuments(document.lienDocument)
                                "
                              >
                                Supprimer
                              </button>
                            </div>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- Diplomes & certifications -->
          <!-- Titre -->
          <div
            class="self-stretch flex-col justify-start items-center gap-6 flex"
          >
            <div class="self-stretch flex-col justify-start items-start flex">
              <div class="self-stretch flex-col justify-start items-start flex">
                <div
                  class="self-stretch title-ctnr justify-start items-start inline-flex"
                >
                  <div
                    class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
                  >
                    <div class="text-4xl font-semibold">
                      Diplômes & certifications
                    </div>
                  </div>
                  <!-- <div class="justify-start items-center gap-3 flex">
                <button
                  class="hover:bg-gray-200 px-4 py-2.5 title-btn rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
                  <div class="w-5 h-5 relative">
                    <img src="assets/icons/plus.png" alt="" />
                  </div>
                  <div
                    class="text-slate-700 text-sm font-interSemibold text-white leading-tight">
                    Ajouter
                  </div>
                </button>
              </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- Tableau -->
          <!-- Debut -->
          <!-- Tableau -->
          <div
            class="self-stretch h-full flex-col justify-start items-center gap-4 flex"
          >
            <div
              class="self-stretch h-full flex-col justify-start items-start flex"
            >
              <div
                class="self-stretch h-full flex-col justify-start items-start flex"
              >
                <div
                  class="tableau-ctnr self-stretch h-full flex-col justify-start items-start flex"
                >
                  <table
                    style="table-layout: auto; word-break: normal"
                    class="mat-elevation-z8 w-full text-sm tableau text-left rtl:text-right text-gray-500"
                  >
                    <thead class="text-sm font-medium f12 bg-orange text-white">
                      <tr>
                        <th scope="row" class="px-6 py-3 white-space-normal">
                          Nom de diplôme
                        </th>
                        <th scope="row" class="px-6 py-3 white-space-normal">
                          Date d'obtention
                        </th>
                        <th scope="row" class="px-6 py-3 white-space-normal">
                          Etablissement
                        </th>
                        <th scope="row" class="px-4 py-3 white-space-normal">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let diplome of diplomes"
                        class="bg-white border-b ng-star-inserted"
                      >
                        <td
                          scope="row"
                          class="py-4 font-semibold text-gray-900"
                          style="padding-left: 1em"
                        >
                          {{ diplome.name }}
                        </td>
                        <td scope="row" class="px-6 py-4 f14 font-semibold">
                          {{ diplome.date_obtention | date }}
                        </td>
                        <td scope="row" class="px-6 py-4 f14 font-semibold">
                          {{ diplome.etablissement }}
                        </td>
                        <td
                          scope="row"
                          class="action-btn-ctnr f14"
                          style="padding-right: 0"
                        >
                          <button
                            class="action-btn cst-transition three-dots p-1 text-gray-700 text-center"
                          >
                            <div
                              class="actions-panel text-left rounded-lg shadow bg-white cst-transition"
                            >
                              <button
                                id=""
                                class="text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                              >
                                Afficher
                              </button>
                              <button
                                id=""
                                class="text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                                (click)="
                                  togglePopupForUpdate(diplome.id, diplome.name)
                                "
                              >
                                Modifier
                              </button>
                              <button
                                id=""
                                class="text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                                (click)="onDeleteDiplome(diplome.id)"
                              >
                                Supprimer
                              </button>
                            </div>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- fin -->
        </div>
      </div>
    </div>
  </div>

  <div
    class="cst-popup ajout-diplome cst-transition w-full {{ classOpen }}"
    *ngIf="popupVisible"
  >
    <button
      class="cst-close-popup bg-white text-gray-900 mat-mdc-input-element self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
      (click)="togglePopup()"
    >
      &times;
    </button>
    <div class="ctnr p-8">
      <form class="w-full grow shrink mb-8" [formGroup]="formDocument">
        <div
          class="form-fields-ctnr w-full self-stretch justify-start items-start gap-6 pr-db p-6"
        >
          <!-- Upload de document en drag and drop -->
          <div
            class="field-ctnr fake-drag-n-drop pt-7 text-center px-3.5 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center"
          >
            <label
              style="cursor: pointer"
              *ngIf="!fileName"
              class="mt-7 pr-db font-semibold text-gray-900 w-full"
              for="ledocument"
              >Importer un document<br />
              <span>(PDF, PNG, JPEG)</span>
            </label>

            <label
              *ngIf="fileSize < maxFileSize"
              class="mb10 pr-db font-semibold w-full text-green-500"
              for="ledocument"
            >
              {{ fileName }}
            </label>
            <label
              *ngIf="fileSize >= maxFileSize"
              class="mb10 pr-db font-medium text-gray-900 w-full"
              for="ledocument"
            >
              Merci de choisir un autre fichier
            </label>

            <input
              id="ledocument"
              type="file"
              accept="image/*, .doc, .docx, .pdf"
              class="none"
              type="file"
              (change)="onChange($event)"
            />
          </div>
          <div
            *ngIf="fileSize >= maxFileSize"
            class="pr-db font-medium w-full text-red"
          >
            Taille de fichier trop grande : {{ fileSize }} KB
          </div>

          <div class="field-ctnr pt-4 justify-start gap-5">
            <label
              class="mb10 pr-db font-semibold text-gray-900 w-full pb-2"
              for="typedocument"
              >Type de document</label
            >
            <select
              id="typedocument"
              class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
              formControlName="documentType"
            >
              <option *ngFor="let type of documentType" [value]="type.name">
                <img src="assets/icons/file-attachment-05.svg" alt="" />
                {{ type.name }}
              </option>
            </select>
          </div>
          <div
            *ngIf="
              formDocument.get('documentType')?.value === 'Diplôme' ||
              formDocument.get('documentType')?.value === 'Certificat'
            "
          >
            <div class="field-ctnr pt-6 justify-start gap-5">
              <label
                class="mb10 pr-db font-medium text-gray-900 w-full"
                for="nomdiplome"
                >Nom du diplôme</label
              >
              <input
                formControlName="nomdiplome"
                id="nomdiplome"
                type="text"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
              />
            </div>
            <div class="field-ctnr pt-6 justify-start gap-5">
              <label
                class="mb10 pr-db font-medium text-gray-900 w-full"
                for="dateobtention"
                >Date d'obtention</label
              >
              <input
                formControlName="dateobtention"
                id="dateobtention"
                type="date"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
              />
            </div>
            <div class="field-ctnr pt-6 justify-start gap-5">
              <label
                class="mb10 pr-db font-medium text-gray-900 w-full"
                for="etabilissement"
                >Etablissement</label
              >
              <input
                formControlName="etablissement"
                id="etablissement"
                type="text"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
              />
            </div>
          </div>
        </div>
        <div
          *ngIf="diplomeName != ''"
          class="px-6 pb-5 font-semibold w-full text-red"
        >
          Vous modifiez le diplôme: {{ diplomeName }}
        </div>
        <div class="w-full inline-flex justify-center items-center gap-5">
          <button
            type="reset"
            class="font-semibold bg-white text-gray-900 mat-mdc-input-element self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
            (click)="togglePopup()"
          >
            Annuler
          </button>
          <button
            *ngIf="isForAddDocument"
            type="submit"
            (click)="onUpload()"
            class="font-semibold bg-blue text-white mat-mdc-input-element self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
          >
            Ajouter</button
          ><button
            *ngIf="isForUpdateDocument"
            type="submit"
            (click)="onUpdate()"
            class="bg-blue text-white mat-mdc-input-element font-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
          >
            Modifier
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
